import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-materias">
            <div className= "titulo-materias">
                <h2>
                Calificaciones (Materias Optativas)
                </h2>
            </div>
        </div>
    );
};

export default Header;